import { z } from 'zod';

export const CoreCustomFieldTypeSchema = z.enum(['Address','Checkbox','Currency','Date','DateTime','Dropdown','DropdownMultiSelect','Email','Number','Percent','PhoneNumber','Text','TextArea','Time','URL','LookUp']);

export type CoreCustomFieldTypeType = `${z.infer<typeof CoreCustomFieldTypeSchema>}`

export default CoreCustomFieldTypeSchema;
